import { BrowserRouter, Routes, Route } from "react-router-dom";

// Public
import PublicLayout from "./public-ui/layout/PublicLayout";
import Home from "./public-ui/pages/Home";
import About from "./public-ui/pages/About";
import Services from "./public-ui/pages/Services";
import PublicProjects from "./public-ui/pages/Projects";
import Contact from "./public-ui/pages/Contact";

// Admin
import Dashboard from "./pages/Dashboard";
import AdminProjects from "./pages/AdminProjects";

function App() {
  return (
    <BrowserRouter>
      <Routes>

        {/* PUBLIC UI */}
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projects" element={<PublicProjects />} />
          <Route path="/contact" element={<Contact />} />
        </Route>

        {/* ADMIN UI */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/projects" element={<AdminProjects />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
